var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { boundMethod } from 'autobind-decorator';
import { v4 as uuid } from 'uuid';
import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { formatPortsHelper } from 'components/powerFlowShared/helpers/nodePortFormatter';
import { SafeInnerHtmlSetter } from 'components/shared/util/SafeInnerHtmlSetter';
import { FlowNode, flowNodeColor, NodeTypeComponent, } from 'fable/flowEditor';
import ActionModal from '../modals/chatmessage';
const portTranslator = (node) => {
    return [
        {
            id: uuid(),
            type: 'out',
            label: 'arrow',
            connection: node.payload.nextNodeId,
        },
    ];
};
export class ChatmessageNode extends NodeTypeComponent() {
    triggerEdit() {
        const { onEdit, node } = this.props;
        onEdit(node, node.nodeType);
    }
    _renderText() {
        const { node: { payload: { text }, }, } = this.props;
        return (_jsx("div", Object.assign({ style: {
                fontStyle: 'normal',
                height: '32px',
                overflow: 'hidden',
            } }, { children: _jsx(SafeInnerHtmlSetter, { element: "div", 
                // message was created by the FieldEditor it has to be injected as html
                content: text }) })));
    }
    render() {
        return (_jsx(FlowNode, { color: ChatmessageNode.color, icon: ChatmessageNode.icon, label: ChatmessageNode.label, text: this._renderText(), onEdit: this.triggerEdit }));
    }
}
ChatmessageNode.icon = 'chat-plus';
ChatmessageNode.label = 'Chat message';
ChatmessageNode.color = flowNodeColor.blue;
ChatmessageNode.height = FlowNode.dimensions.h + 16;
ChatmessageNode.translatePayload = formatPortsHelper(portTranslator);
ChatmessageNode.ActionModal = ActionModal;
ChatmessageNode.actionTrigger = { type: FlowNodeTypes.CHAT_MESSAGE };
ChatmessageNode.updateConnection = (node, _port, newConnection) => {
    const payload = Object.assign({}, node.payload);
    payload.nextNodeId = newConnection;
    return Object.assign(Object.assign({}, node), { payload });
};
__decorate([
    boundMethod
], ChatmessageNode.prototype, "triggerEdit", null);
